import React, { useContext, useState, useEffect } from "react";
import {
  GameBoardContext,
  AppContext,
  ValueContext,
} from "../../context/createContext";
import AdditionalInfo from "./elements/AdditionalInfo";
import BetBlock from "./elements/betBlock/BetBlock";
import { BetingBlocksWrapper, Bigcontainer } from "./elements/ElementsStyles";
import {
  handleBet,
  footerStateHandler,
  refreshHandler,
  cashoutValueHandler,
  placeBet,
  cashoutHandler,
} from "./handler";
// import { Notifications } from "@orbital/games-frontend-library"

export default function Footer({
  removeComponents,
  popup,
  isJackpot,
  isLoading,
}: any) {
  const { stakes, funcs, auto, footerStates, firstIsPlaying, secondIsPlaying } =
    useContext(GameBoardContext);
  const {
    handleShowAuto,
    handleStake,
    setFooterFirstState,
    setFooterSecondState,
    handleAutoInputs,
  } = funcs;
  const {
    auth,
    balanceUpdate,
    stellarSocketMessages,
    placedBetFirst,
    placedBetSecond,
    handleNotification,
    roundUserUpdate,
    appFuncs,
    notification,
    jackpot,
    settings,
    config,
  } = useContext(AppContext);
  const { clearBetResponse } = appFuncs;
  const { roundupdate } = useContext(ValueContext);
  const { state } = roundupdate;
  const {
    balance: { amount },
    player_id,
  } = auth;
  const { firstState, secondState } = footerStates;

  const [updateBalance, setUpdateBalance] = useState(amount);

  const [cashoutFirstStake, setCashoutFirstStake] = useState<any>(0);
  const [cashoutSecondStake, setCashoutSecondStake] = useState<any>(0);

  const [firstBetClicked, setFirstBetClicked] = useState(false);
  const [secondBetClicked, setSecondBetClicked] = useState(false);
  const [firstBetForNextRound, setFirstBetForNextRound] = useState(false);
  const [secondBetForNextRound, setSecondBetForNextRound] = useState(false);
  const [disabledFirstBlock, setDisabledFirstBlock] = useState(false);
  const [disabledSecondBlock, setDisabledSecondBlock] = useState(false);

  const [firstBetCashouted, setFirstBetCashouted] = useState<boolean>(false);
  const [secondBetCashouted, setSecondBetCashouted] = useState<boolean>(false);

  useEffect(() => {
    const balanceNew =
      balanceUpdate.balance !== "" ? balanceUpdate.balance : amount;
    setUpdateBalance(balanceNew);
  }, [balanceUpdate, amount, updateBalance]);

  useEffect(() => {
    refreshHandler(placedBetFirst, setFirstBetClicked);
  }, [placedBetFirst]);

  useEffect(() => {
    refreshHandler(placedBetSecond, setSecondBetClicked);
  }, [placedBetSecond]);

  // მესამე სთეითში წინა რესფონსები რომ გაასუფთაოს
  useEffect(() => {
    state === 3 && clearBetResponse();
  }, [state]);

  useEffect(() => {
    if (player_id === roundUserUpdate.id) {
      if (roundUserUpdate.index == "0" && roundUserUpdate.cashout > 0) {
        setFirstBetCashouted(true);
      }
      if (roundUserUpdate.index == "1" && roundUserUpdate.cashout > 0) {
        setSecondBetCashouted(true);
      }
    }
  }, [roundUserUpdate]);

  // footer state handler for first block
  useEffect(() => {
    footerStateHandler(
      state,
      firstBetClicked,
      firstBetForNextRound,
      setFirstBetForNextRound,
      setFirstBetClicked,
      setDisabledFirstBlock,
      setFooterFirstState,
      auto,
      handleAutoInputs,
      firstState,
      "first",
      handleNotification,
      placedBetFirst,
      firstBetCashouted,
      setFirstBetCashouted,
      isJackpot
    );
  }, [
    state,
    firstBetForNextRound,
    firstBetClicked,
    auto.first.showAuto,
    auto.second.showAuto,
    // placedBetFirst,
    firstBetCashouted,
    isJackpot,
  ]);
  // footer state handler for second block
  useEffect(() => {
    footerStateHandler(
      state,
      secondBetClicked,
      secondBetForNextRound,
      setSecondBetForNextRound,
      setSecondBetClicked,
      setDisabledSecondBlock,
      setFooterSecondState,
      auto,
      handleAutoInputs,
      secondState,
      "second",
      handleNotification,
      placedBetSecond,
      secondBetCashouted,
      setSecondBetCashouted,
      isJackpot
    );
  }, [
    state,
    secondBetForNextRound,
    secondBetClicked,
    auto.first.showAuto,
    auto.second.showAuto,
    // placedBetSecond,
    secondBetCashouted,
    isJackpot,
  ]);

  // აქ ერთად რომ წერია ორივე ბეთის გაგზავნა პირველი ბეთი ორჯერ იგზავნება რაღაც ეტაპზე და ერორი მოდის, პირველი ბეთის გაფოლსება არ გამოვა ფუტერი არ შეიცვლება
  useEffect(() => {
    if (state === 1 && firstBetClicked && !placedBetFirst.bet) {
      placeBet(
        stellarSocketMessages,
        stakes,
        0,
        auto.first.showAuto ? Number(auto.first.cashOut) : 0,
        settings.audio
      );
    }
  }, [state, firstBetClicked, auto.first.showAuto, placedBetFirst]);

  useEffect(() => {
    if (state === 1 && secondBetClicked && !placedBetSecond.bet) {
      placeBet(
        stellarSocketMessages,
        stakes,
        1,
        auto.second.showAuto ? Number(auto.second.cashOut) : 0,
        settings.audio
      );
    }
  }, [state, secondBetClicked, auto.second.showAuto, placedBetSecond]);

  // useEffect(() => {
  //   stellarSocketMessages &&
  //     setTimeout(() => {
  //       getJackpot(stellarSocketMessages)
  //     }, 8000)
  // }, [stellarSocketMessages])
  // cashout value update
  useEffect(() => {
    if (firstIsPlaying) {
      const firstValue = Number(
        cashoutValueHandler(roundupdate.value, stakes.firstStake, config.prec)
      );
      setCashoutFirstStake(firstValue);
    }
    if (secondIsPlaying) {
      const secondValue = Number(
        cashoutValueHandler(roundupdate.value, stakes.secondStake, config.prec)
      );
      setCashoutSecondStake(secondValue);
    }
  }, [
    roundupdate.value,
    stakes,
    auto.first.showAuto,
    auto.second.showAuto,
    firstIsPlaying,
    secondIsPlaying,
  ]);

  const betHandler = (s: any) => {
    if (s === "first" && firstBetClicked && state === 2 && placedBetFirst.bet) {
      cashoutHandler(
        stellarSocketMessages,
        setFirstBetClicked,
        setFirstBetForNextRound,
        s,
        false
      );
    } else if (
      s === "second" &&
      secondBetClicked &&
      state === 2 &&
      placedBetSecond.bet
    ) {
      cashoutHandler(
        stellarSocketMessages,
        setSecondBetClicked,
        setSecondBetForNextRound,
        s,
        false
      );
    } else {
      s === "first"
        ? handleBet(
            s,
            state,
            firstBetClicked,
            firstBetForNextRound,
            setFirstBetForNextRound,
            setFirstBetClicked,
            handleAutoInputs
          )
        : handleBet(
            s,
            state,
            secondBetClicked,
            secondBetForNextRound,
            setSecondBetForNextRound,
            setSecondBetClicked,
            handleAutoInputs
          );
    }
  };

  const handleAutoConfigOne = () => {
    firstIsPlaying && betHandler("first");
    auto.first.showAuto
      ? handleShowAuto(false, auto.second.showAuto)
      : handleShowAuto(true, auto.second.showAuto);
  };
  const handleAutoConfigTwo = () => {
    secondIsPlaying && betHandler("second");
    auto.second.showAuto
      ? handleShowAuto(auto.first.showAuto, false)
      : handleShowAuto(auto.first.showAuto, true);
  };

  useEffect(() => {
    if (notification === "Invalid action") {
      if (placedBetFirst.bet === "") {
        setFirstBetClicked(false);
      }
      if (placedBetSecond.bet === "") {
        setSecondBetClicked(false);
      }
    }
  }, [placedBetFirst, placedBetSecond, notification]);

  return (
    <>
      {!popup && (
        <Bigcontainer
          className="bigcontainer"
          removeComponents={removeComponents}
          popup={popup}
        >
          <AdditionalInfo
            autoActive={auto.first.showAuto || auto.second.showAuto}
            isLoading={isLoading}
          />
          <BetingBlocksWrapper>
            <BetBlock
              firstBlock
              autoPilotNumber={"first"}
              stake={stakes.firstStake}
              handleAutoConfigs={() => handleAutoConfigOne()}
              active={auto.first.showAuto}
              handleStake={(s: string) => handleStake(s, stakes.secondStake)}
              handleBet={(s: any) => betHandler(s)}
              cashoutStake={cashoutFirstStake}
              footerState={firstState}
              disabled={disabledFirstBlock}
              isJackpot={jackpot.status === "start"}
              isPlaying={firstIsPlaying}
              popup={popup}
            />
            <BetBlock
              stake={stakes.secondStake}
              autoPilotNumber={"second"}
              handleAutoConfigs={() => handleAutoConfigTwo()}
              active={auto.second.showAuto}
              handleStake={(s: string) => handleStake(stakes.firstStake, s)}
              handleBet={(s: any) => betHandler(s)}
              cashoutStake={cashoutSecondStake}
              footerState={secondState}
              disabled={disabledSecondBlock}
              isJackpot={jackpot.status === "start"}
              isPlaying={secondIsPlaying}
              popup={popup}
            />
          </BetingBlocksWrapper>
        </Bigcontainer>
      )}
    </>
  );
}
